import { render, staticRenderFns } from "./WtIconButton.vue?vue&type=template&id=2e81fffa&scoped=true&lang=pug&"
import script from "./WtIconButton.vue?vue&type=script&lang=js&"
export * from "./WtIconButton.vue?vue&type=script&lang=js&"
import style0 from "./WtIconButton.vue?vue&type=style&index=0&id=2e81fffa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e81fffa",
  null
  
)

export default component.exports